import { saveAs }           from 'file-saver'
import { Midi }             from '@tonejs/midi'
import SegmentIO            from 'reporting/SegmentIO'

const JSZip      = require('jszip')
const MidiWriter = require('midi-writer-js')

export function notesToMidiTrack({ notes, duration = '4n' }) {
  const track = new MidiWriter.Track()
  track.addEvent(new MidiWriter.ProgramChangeEvent({ instrument: 1 }))
  if(notes) {
    const pitch      = [...notes].map(note => note.toString())
    duration         = duration.slice(0, duration.length - 1)
    const notesEvent = new MidiWriter.NoteEvent({ pitch, duration })
    track.addEvent(notesEvent)
  }

  return new MidiWriter.Writer(track)
}

export function voiceToMidiTrack(voice) {
  const track = new MidiWriter.Track()
  track.addEvent(new MidiWriter.ProgramChangeEvent({ instrument: 1 }))
  voice.forEach(measure => {
    measure.data.forEach(({ notes, duration }) => {
      if(notes) {
        const pitch      = [...notes].map(note => note.toString())
        duration         = duration.slice(0, duration.length - 1)
        const notesEvent = new MidiWriter.NoteEvent({ pitch, duration })
        track.addEvent(notesEvent)
      }
    })
  })

  return new MidiWriter.Writer(track)
}

export async function trackToDownloadObject(midiWriter, name) {
  const midi   = await Midi.fromUrl(midiWriter.dataUri())
  const buffer = new Buffer(midi.toArray())
  return new Promise((resolve => {
    resolve({ name, data: buffer })
  }))
}

export function downloadMultipleFiles(files) {
  const dataTypes     = ['scales', 'chords', 'progressions', 'scores']
  const analyticsData = {}
  dataTypes.forEach(type => analyticsData[type] = 0)
  files.map(file => file.name)
       .forEach(filename => {
         const type = filename.split('/')[0]
         if(dataTypes.includes(type)) {
           analyticsData[type]++
         }
       })
  SegmentIO.midiDownload(analyticsData)
  const zip = new JSZip()

  files.forEach(file => {
    zip.file(`${file.name}.mid`, file.data)
  })

  zip.generateAsync({ type: 'blob' })
     .then((blob) => {
       saveAs(blob, 'midi-files.zip')
     })
}
